import React from 'react';

interface PlanHighlightProps {
  type: 'credits' | 'exhausted' | 'warning';
  value: number | string;
  label: string;
  sublabel: string;
  icon: React.ReactNode;
  theme?: 'light' | 'dark';
}

export const PlanHighlight: React.FC<PlanHighlightProps> = ({
  type,
  value,
  label,
  sublabel,
  icon,
  theme = 'dark'
}) => {
  const getContainerClasses = () => {
    const baseClasses = 'backdrop-blur-sm rounded-xl p-4 max-w-sm mx-auto';
    return theme === 'dark' 
      ? `${baseClasses} bg-white/20`
      : `${baseClasses} bg-white/80 border border-orange-200`;
  };

  const getIconContainerClasses = () => {
    switch (type) {
      case 'credits':
        return 'bg-green-500 p-2 rounded-full';
      case 'exhausted':
        return 'bg-red-500 p-2 rounded-full';
      case 'warning':
        return 'bg-orange-500 p-2 rounded-full';
      default:
        return 'bg-blue-500 p-2 rounded-full';
    }
  };

  const getTextClasses = () => {
    return theme === 'dark' 
      ? {
          value: 'text-white font-semibold text-lg',
          sublabel: 'text-white/80 text-sm'
        }
      : {
          value: 'text-orange-800 font-semibold text-lg',
          sublabel: 'text-orange-600 text-sm'
        };
  };

  const textClasses = getTextClasses();

  return (
    <div className={getContainerClasses()}>
      <div className="flex items-center justify-center space-x-3">
        <div className={getIconContainerClasses()}>
          <div className="h-5 w-5 text-white">
            {icon}
          </div>
        </div>
        <div className="text-left">
          <div className={textClasses.value}>
            {value}
          </div>
          <div className={textClasses.sublabel}>
            {sublabel}
          </div>
        </div>
      </div>
    </div>
  );
};